import React, { useEffect, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Alert, Badge, Spinner, Table } from "reactstrap";
import { getCurrentUser } from "../../api/base";
import usuarios, { UsuarioResponse } from "../../api/usuarios";
import { errorToString } from "../../helpers/funcoes";
import { Titulo } from "../Titulo";

export function UsuariosLista() {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<UsuarioResponse[]>();
  const [error, setError] = useState<string>();
  const currentUser = getCurrentUser();

  useEffect(() => {
    setLoading(true);
    usuarios
      .getUsuarios(false) // Only get active users
      .then((res) => setItems(res))
      .catch((err) => setError(errorToString(err)))
      .finally(() => setLoading(false));
    return () => setItems(undefined);
  }, []);

  const onDeactivate = (
    e: React.MouseEvent<HTMLAnchorElement>,
    usuario: string
  ) => {
    e.preventDefault();

    if (!confirm(`Deseja realmente desativar o usuário "${usuario}"?`)) {
      return;
    }

    setLoading(true);
    setError(undefined);

    usuarios
      .deactivateUsuario(usuario)
      .then(() => usuarios.getUsuarios(false).then((res) => setItems(res)))
      .catch((err) => setError(errorToString(err)))
      .finally(() => setLoading(false));
  };

  if (loading) {
    return (
      <div className="text-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div>
      <Titulo text="Usuários" />
      {error && (
        <Alert color="danger" data-cy="alert">
          {error}
        </Alert>
      )}
      <div className="text-end">
        <Link to="form">Adicionar</Link>
      </div>
      <Table>
        <thead>
          <tr>
            <th>Usuário</th>
            <th>Perfis</th>
            <th>Status</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {items?.map((item) => {
            const isCurrentUser = item.usuario === currentUser;
            
            return (
            <tr key={item.usuario}>
              <td>{item.usuario}</td>
              <td>
                {item.perfis.map((perfil, index) => (
                  <Badge key={index} color="primary" className="me-1">
                    {perfil}
                  </Badge>
                ))}
              </td>
              <td>
                <Badge color={item.isActive ? "success" : "danger"}>
                  {item.isActive ? "Ativo" : "Inativo"}
                </Badge>
              </td>
              <td className="text-end">
                <Link 
                  to={!isCurrentUser ? `form/${item.usuario}` : "#"}
                  data-cy={`edit`}
                  className={isCurrentUser ? "text-muted" : ""}
                  style={isCurrentUser ? { pointerEvents: 'none', cursor: 'default' } : {}}
                  title={isCurrentUser ? "Não é possível editar próprio usuário" : "Editar usuário"}
                >
                  <FaEdit />
                </Link>
                &nbsp; &nbsp;
                <Link
                  to={`./`}
                  onClick={!isCurrentUser ? (e) => onDeactivate(e, item.usuario) : (e) => e.preventDefault()}
                  data-cy={`delete`}
                  className={isCurrentUser ? "text-muted" : ""}
                  style={isCurrentUser ? { pointerEvents: 'none', cursor: 'default' } : {}}
                  title={isCurrentUser ? "Não é possível desativar próprio usuário" : "Desativar usuário"}
                >
                  <FaTrash />
                </Link>
              </td>
            </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
